import {
  IChangeSimEsimOrchestrator,
  IMobileOrchestrator,
} from "@nju/data-access-portal-orchestrator";
import { Button, Separator } from "@nju/ui";
import {
  formatAddress,
  formatDate,
  formatPhoneNumber,
  POSITIVE_DIGITS,
} from "@nju/utils";
import { DetailsSection } from "./DetailsSection";

interface IChangeSimEsimBannerDetailsProps {
  handleOpenDPDLink: () => void;
  mobileOrchestrator: IMobileOrchestrator | undefined;
  changeSimEsimOrchestrator: IChangeSimEsimOrchestrator | undefined;
}

export function ChangeSimEsimBannerDetails({
  handleOpenDPDLink,
  changeSimEsimOrchestrator,
}: IChangeSimEsimBannerDetailsProps) {
  return (
    <>
      <Separator size="s" tone="invisible" />
      <DetailsSection
        description="przesyłka gotowa"
        iconName="sim-card"
        title="status"
      />
      <Separator size="m" />
      <DetailsSection
        description="0 zł"
        iconName="money-bill"
        title="kwota brutto"
      />
      {changeSimEsimOrchestrator?.orderModifiedAt && (
        <>
          <Separator size="xs" tone="invisible" />
          <DetailsSection
            description={formatDate(
              changeSimEsimOrchestrator.orderModifiedAt,
              false,
            )}
            iconName="calendar"
            title="data zamówienia"
          />
        </>
      )}
      <Separator size="m" />
      <div className="flex flex-wrap only-mobile:flex-col only-mobile:gap-3">
        {changeSimEsimOrchestrator?.delivery?.contactNumber && (
          <div className="flex-[0_0_50%] from-tablet:pr-1">
            <DetailsSection
              description={formatPhoneNumber(
                changeSimEsimOrchestrator.delivery.contactNumber,
                POSITIVE_DIGITS,
                " ",
                "+48",
              )}
              iconName="phone"
              title="numer do kontaktu (dla kuriera)"
            />
            <Separator size="xs" tone="invisible" />
          </div>
        )}
        {changeSimEsimOrchestrator?.delivery?.note && (
          <div className="flex-[0_0_50%] from-tablet:pl-1">
            <DetailsSection
              description={changeSimEsimOrchestrator.delivery.note}
              iconName="comment"
              title="wiadomość dla kuriera"
            />
            <Separator size="xs" tone="invisible" />
          </div>
        )}
        {changeSimEsimOrchestrator?.delivery && (
          <div className="flex-[0_0_50%] from-tablet:pr-1">
            <DetailsSection
              description={formatAddress(
                changeSimEsimOrchestrator.delivery,
                true,
              )}
              iconName="map-marked-alt"
              title="adres dostawy karty SIM"
            />
          </div>
        )}
      </div>
      <Separator size="s" tone="invisible" />
      <Button
        id="button_nm_sledz_zamowienie"
        onPress={handleOpenDPDLink}
        size={{
          "@onlyMobile": "s",
        }}
        variant="secondary"
      >
        śledź zamówienie
      </Button>
    </>
  );
}
